export const GET_MEMBER_UNIONS = "GET_MEMBER_UNIONS";
export const GET_MEMBER_UNION_BY_ID = "GET_MEMBER_UNION_BY_ID";
export const UPDATE_MEMBER_UNION = "UPDATE_MEMBER_UNION";
export const DELETE_MEMBER_UNION = "DELETE_MEMBER_UNION";
export const CREATE_MEMBER_UNION = "CREATE_MEMBER_UNION";
